import Contract from './contract';

export default Contract;